import * as React from 'react'

import { styled } from '~/styled'

import { Image } from '../../image/Image'
import { useBannerContext } from '../BannerContext'

const Container = styled(
  'div',
  {
    base: ['relative', 'overflow-hidden', 'w-19/50'],
    variants: {
      size: {
        sm: ['hidden'],
        md: ['block']
      }
    }
  },
  {
    enabledResponsiveVariants: true
  }
)

const StyledImage = styled(Image, {
  base: ['absolute', 'max-w-none', 'size-full', 'object-cover']
})

export const BannerRegularImage = (
  props: React.ComponentPropsWithoutRef<typeof Image>
) => {
  const { size } = useBannerContext()

  return (
    <Container size={size}>
      <StyledImage {...props} />
    </Container>
  )
}

BannerRegularImage.displayName = 'BannerRegularImage'
